/* eslint no-barrel-files/no-barrel-files: off -- Alloy's synchronous dynamic transform requires direct named exports from this shared chunk. */
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import {ArtifactsEntrypoint} from './ArtifactsRoute'
import {ChecksEntrypoint} from './Checks'
import {CommitsEntrypoint, CommitsWithRangeEntrypoint} from './Commits'
import {ConversationsEntrypoint} from './Conversations'
import type {PullRequestsRouteComponents} from './create-pull-requests-routes'
import {ChangesEntrypoint, ChangesWithRangeEntrypoint} from './FilesChanged'
import {FindingsEntrypoint} from './FindingsRoute'
import {LayoutEntrypoint} from './Layout'
import {OverviewRouteEntrypoint} from './Overview'
import {RepoPullsDashboardContent} from './RepoPullsDashboardContent'
import {RepoPullsDashboardLayout} from './RepoPullsDashboardLayout'
import {RepoStackDetail} from './RepoStackDetail'
import {RepoStacksList} from './RepoStacksList'

export {
  ArtifactsEntrypoint,
  ChangesEntrypoint,
  ChangesWithRangeEntrypoint,
  ChecksEntrypoint,
  CommitsEntrypoint,
  CommitsWithRangeEntrypoint,
  ConversationsEntrypoint,
  FindingsEntrypoint,
  LayoutEntrypoint,
  OverviewRouteEntrypoint,
  PullRequestErrorState,
  RepoPullsDashboardContent,
  RepoPullsDashboardLayout,
  RepoStackDetail,
  RepoStacksList,
}

export const pullRequestsRouteComponents = {
  PullRequestErrorState,
  LayoutEntrypoint,
  CommitsEntrypoint,
  CommitsWithRangeEntrypoint,
  ChangesEntrypoint,
  ChangesWithRangeEntrypoint,
  ConversationsEntrypoint,
  ChecksEntrypoint,
  OverviewRouteEntrypoint,
  FindingsEntrypoint,
  ArtifactsEntrypoint,
  RepoPullsDashboardContent,
  RepoPullsDashboardLayout,
  RepoStacksList,
  RepoStackDetail,
} satisfies PullRequestsRouteComponents
